import { supabase } from './supabase';
import type { Message } from './supabase';

export async function createChat(title: string) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  try {
    const { data, error } = await supabase
      .from('chats')
      .insert({ 
        user_id: user.id, 
        title: title || 'Nova conversa' 
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error creating chat:', error);
    throw new Error('Não foi possível criar o chat. Tente novamente.');
  }
}

export async function getChats() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  try {
    const { data, error } = await supabase
      .from('chats')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching chats:', error);
    return [];
  }
}

export async function getMessages() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  try {
    // Get or create user's chat
    let chatId: string;
    const { data: existingChats, error: chatError } = await supabase
      .from('chats')
      .select('id')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false })
      .limit(1);

    if (chatError) throw chatError;

    if (!existingChats?.length) {
      const { data: newChat } = await createChat('Nova conversa');
      if (!newChat) throw new Error('Failed to create chat');
      chatId = newChat.id;
    } else {
      chatId = existingChats[0].id;
    }

    const { data, error } = await supabase
      .from('messages')
      .select('*')
      .eq('chat_id', chatId)
      .order('created_at', { ascending: true });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error fetching messages:', error);
    return [];
  }
}

export async function addMessage(message: {
  role: 'user' | 'assistant';
  content: string;
  assistant_id?: string | null;
}) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  try {
    // Get or create user's chat
    let chatId: string;
    const { data: existingChats, error: chatError } = await supabase
      .from('chats')
      .select('id')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false })
      .limit(1);

    if (chatError) throw chatError;

    if (!existingChats?.length) {
      const { data: newChat } = await createChat('Nova conversa');
      if (!newChat) throw new Error('Failed to create chat');
      chatId = newChat.id;
    } else {
      chatId = existingChats[0].id;
    }

    const { data, error } = await supabase
      .from('messages')
      .insert({
        chat_id: chatId,
        ...message
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error adding message:', error);
    throw new Error('Não foi possível enviar a mensagem. Tente novamente.');
  }
}